import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { resetState } from "../../redux/common/commonAction";
import Unauthorized from "views/Pages/Unauthorized";
import Header from "components/Headers/Header.js";
import {
  Card,
  Container,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  Button
} from "reactstrap";
import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import { toast } from "react-toastify";

function CheckSetting(props) {
  const [unauthorized, setUnauthorized] = useState(false);
  const [metroCheckNumberPrefix, setMetroCheckNumberPrefix] = useState(0);
  const [coinCheckNumberPrefix, setCoinCheckNumberPrefix] = useState(0);
  const [receiptCheckNumberPrefix, setReceiptCheckNumberPrefix] = useState(0);
  const [jewelryreceiptCheckNumberPrefix, setJewelryreceiptCheckNumberPrefix] = useState(0);
  const [metroCheckNextSequenceNumber, setMetroCheckNextSequenceNumber] = useState(0);
  const [coinCheckNextSequenceNumber, setCoinCheckNextSequenceNumber] = useState(0);
  //
  const [dateXPosition, setDateXPosition] = useState(0);
  const [dateYPosition, setDateYPosition] = useState(0);
  const [amountNumberXPosition, setAmountNumberXPosition] = useState(0);
  const [amountNumberYPosition, setAmountNumberYPosition] = useState(0);
  const [amountAsFullTextXPosition, setAmountAsFullTextXPosition] = useState(0);
  const [amountAsFullTextYPosition, setAmountAsFullTextYPosition] = useState(0);
  const [memoXPosition, setMemoXPosition] = useState(0);
  const [memoYPosition, setMemoYPosition] = useState(0);
  const [payeeXPosition, setPayeeXPosition] = useState(0);
  const [payeeYPosition, setPayeeYPosition] = useState(0);
  const [signatureXPosition, setSignatureXPosition] = useState(0);
  const [signatureYPosition, setSignatureYPosition] = useState(0);
  const [checkOffsetPosition, setCheckOffsetPosition] = useState(0);

  useEffect(() => {
    GetApiActionWithAuthorization("common/get-check-setting").then((res) => {
      setMetroCheckNumberPrefix(res.data.metroCheckNumberPrefix.toString() + res.data.metroCheckNextSequenceNumber);
      setCoinCheckNumberPrefix(res.data.coinCheckNumberPrefix.toString() + res.data.coinCheckNextSequenceNumber);
      setReceiptCheckNumberPrefix(res.data.receiptCheckNumberPrefix);
      setJewelryreceiptCheckNumberPrefix(res.data.jewelryreceiptCheckNumberPrefix);
      //positions
      setDateXPosition(res.data.dateXPosition);
      setDateYPosition(res.data.dateYPosition);
      setAmountNumberXPosition(res.data.amountNumberXPosition);
      setAmountNumberYPosition(res.data.amountNumberYPosition);
      setAmountAsFullTextXPosition(res.data.amountAsFullTextXPosition);
      setAmountAsFullTextYPosition(res.data.amountAsFullTextYPosition);
      setMemoXPosition(res.data.memoXPosition);
      setMemoYPosition(res.data.memoYPosition);
      setPayeeXPosition(res.data.payeeXPosition);
      setPayeeYPosition(res.data.payeeYPosition);
      setSignatureXPosition(res.data.signatureXPosition);
      setSignatureYPosition(res.data.signatureYPosition);
      setCheckOffsetPosition(res.data.checkOffsetPosition);
    }).catch((err) => {
      if (err.status === 440) {
        toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
        props.history.push("/auth/login");
      }
    });
  }, []);

  const saveCheckPositionHandler = (e) => {
    let body = {
      payeeXPosition,
      payeeYPosition,
      dateXPosition,
      dateYPosition,
      amountNumberXPosition,
      amountNumberYPosition,
      amountAsFullTextXPosition,
      amountAsFullTextYPosition,
      memoXPosition,
      memoYPosition,
      signatureXPosition,
      signatureYPosition,
      checkOffsetPosition
    };
    PostApiWithAuthorizationAction("common/save-check-setting", body)
      .then((res) => {
        toast.success("Setting Updated Successfully!", { position: toast.POSITION.TOP_RIGHT });
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  }

  const saveCheckSettingHandler = (e) => {
    let body = {
      metroCheckNumberPrefix,
      coinCheckNumberPrefix,
      receiptCheckNumberPrefix,
      jewelryreceiptCheckNumberPrefix,
      metroCheckNextSequenceNumber,
      coinCheckNextSequenceNumber
    };
    PostApiWithAuthorizationAction("common/save-check-setting", body)
      .then((res) => {
        toast.success("Setting Updated Successfully!", { position: toast.POSITION.TOP_RIGHT });
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  return unauthorized ? (
    <Unauthorized />
  ) : (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9 main-content" fluid>
        <Card className="card-height shadow">
          <CardHeader className="">
            <div className="text-center">
              <h1>Check Setting</h1>
            </div>
          </CardHeader>
          <CardBody className="checks-main-content page-main-content">
            <div class="box-section mb-3 pb-1" style={{marginTop: '20px'}}>
              <div class="box-section-header">CHECK NUMBER PREFIX</div>
              <div class="box-section-body py-0">
                <Row className="mb-1">
                  <Col md="3">
                    <Label
                      className="form-control-label font-weight-bold"
                      for="metro_check_prefix">Metro Check#</Label>
                    <Input
                      id="metroCheckNumberPrefix"
                      type="text"
                      placeholder="Metro Check Number Prefix"
                      value={metroCheckNumberPrefix}
                      onChange={(e) => setMetroCheckNumberPrefix(e.target.value)}
                    />
                    <span className="text-danger"><small>*required</small>*</span>
                  </Col>
                  <Col md="3">
                    <Label
                      className="form-control-label font-weight-bold"
                      for="coin_check_prefix">Coin Check#</Label>
                    <Input
                        id="coinCheckNumberPrefix"
                        type="text"
                        placeholder="Coin Check Number Prefix"
                        value={coinCheckNumberPrefix}
                        onChange={(e) => setCoinCheckNumberPrefix(e.target.value)}
                      />
                    <span className="text-danger"><small>*required</small>*</span>
                  </Col>
                  <Col md="3">
                    <Label
                      className="form-control-label font-weight-bold"
                      for="receipt_check_prefix">Receipt Check# Prefix</Label>
                    <Input
                        id="receiptCheckNumberPrefix"
                        type="text"
                        placeholder="Receipt Check Number Prefix"
                        value={receiptCheckNumberPrefix}
                        onChange={(e) => setReceiptCheckNumberPrefix(e.target.value)}
                      />
                    <span className="text-danger"><small>*required</small>*</span>
                  </Col>
                  <Col md="3">
                    <Label
                      className="form-control-label font-weight-bold"
                      for="receipt_check_prefix">Jewelry Receipt Check# Prefix</Label>
                    <Input
                        id="jewelryreceiptCheckNumberPrefix"
                        type="text"
                        placeholder="Jewelry Receipt Check Number Prefix"
                        value={jewelryreceiptCheckNumberPrefix}
                        onChange={(e) => setJewelryreceiptCheckNumberPrefix(e.target.value)}
                      />
                    <span className="text-danger"><small>*required</small>*</span>
                  </Col>
                </Row>
                <div className="text-right">
                  <Button
                    id="add-btn"
                    color="success"
                    onClick={saveCheckSettingHandler}
                    size="sm"
                    disabled={metroCheckNumberPrefix <= 0 || coinCheckNumberPrefix <= 0 || receiptCheckNumberPrefix <= 0}
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            </div>
            <div class="box-section mb-3 pb-1">
              <div class="box-section-header">CHECK PRINTING CONFIGURATION</div>
              <div class="box-section-body py-0">
                <Row className="mb-1">
                  <Col md="3">
                    <div class="text-center">
                      <Label
                        className="form-control-label font-weight-bold mb-0"
                        for="metro_check_prefix">Payee Position</Label>
                    </div>
                    <Row className="mb-1">
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">X<span className="text-danger">*</span></Label>
                        <Input
                          id="inputPayeeXPosition"
                          type="text"
                          placeholder=""
                          value={payeeXPosition}
                          onChange={(e) => setPayeeXPosition(e.target.value)}
                        />
                      </Col>
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">Y<span className="text-danger">*</span></Label>
                        <Input
                          id="inputPayeeYPosition"
                          type="text"
                          placeholder=""
                          value={payeeYPosition}
                          onChange={(e) => setPayeeYPosition(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md="3">
                    <div class="text-center">
                      <Label
                        className="form-control-label font-weight-bold mb-0"
                        for="metro_check_prefix">Date Position</Label>
                    </div>
                    <Row className="mb-1">
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">X<span className="text-danger">*</span></Label>
                        <Input
                          id="inputDateXPosition"
                          type="text"
                          placeholder=""
                          value={dateXPosition}
                          onChange={(e) => setDateXPosition(e.target.value)}
                        />
                      </Col>
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">Y<span className="text-danger">*</span></Label>
                        <Input
                          id="inputDateYPosition"
                          type="text"
                          placeholder=""
                          value={dateYPosition}
                          onChange={(e) => setDateYPosition(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md="3">
                    <div class="text-center">
                      <Label
                        className="form-control-label font-weight-bold mb-0"
                        for="metro_check_prefix">Amount Number Position</Label>
                    </div>
                    <Row className="mb-1">
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">X<span className="text-danger">*</span></Label>
                        <Input
                          id="inputAmountNumberXPosition"
                          type="text"
                          placeholder=""
                          value={amountNumberXPosition}
                          onChange={(e) => setAmountNumberXPosition(e.target.value)}
                        />
                      </Col>
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">Y<span className="text-danger">*</span></Label>
                        <Input
                          id="inputAmountNumberYPosition"
                          type="text"
                          placeholder=""
                          value={amountNumberYPosition}
                          onChange={(e) => setAmountNumberYPosition(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md="3">
                    <div class="text-center">
                      <Label
                        className="form-control-label font-weight-bold mb-0"
                        for="metro_check_prefix">Amount Text Position</Label>
                    </div>
                    <Row className="mb-1">
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">X<span className="text-danger">*</span></Label>
                        <Input
                          id="inputAmountAsFullTextXPosition"
                          type="text"
                          placeholder=""
                          value={amountAsFullTextXPosition}
                          onChange={(e) => setAmountAsFullTextXPosition(e.target.value)}
                        />
                      </Col>
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">Y<span className="text-danger">*</span></Label>
                        <Input
                          id="inputAmountAsFullTextYPosition"
                          type="text"
                          placeholder=""
                          value={amountAsFullTextYPosition}
                          onChange={(e) => setAmountAsFullTextYPosition(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md="3">
                    <div class="text-center">
                      <Label
                        className="form-control-label font-weight-bold mb-0"
                        for="metro_check_prefix">Memo Position</Label>
                    </div>
                    <Row className="mb-1">
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">X<span className="text-danger">*</span></Label>
                        <Input
                          id="inputMemoXPosition"
                          type="text"
                          placeholder=""
                          value={memoXPosition}
                          onChange={(e) => setMemoXPosition(e.target.value)}
                        />
                      </Col>
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">Y<span className="text-danger">*</span></Label>
                        <Input
                          id="inputMemoYPosition"
                          type="text"
                          placeholder=""
                          value={memoYPosition}
                          onChange={(e) => setMemoYPosition(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md="3">
                    <div class="text-center">
                      <Label
                        className="form-control-label font-weight-bold mb-0"
                        for="metro_check_prefix">Signature Position</Label>
                    </div>
                    <Row className="mb-1">
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">X<span className="text-danger">*</span></Label>
                        <Input
                          id="inputSignatureXPosition"
                          type="text"
                          placeholder=""
                          value={signatureXPosition}
                          onChange={(e) => setSignatureXPosition(e.target.value)}
                        />
                      </Col>
                      <Col md="6">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">Y<span className="text-danger">*</span></Label>
                        <Input
                          id="inputSignatureYPosition"
                          type="text"
                          placeholder=""
                          value={signatureYPosition}
                          onChange={(e) => setSignatureYPosition(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md="2">
                    <Label
                      className="form-control-label font-weight-bold mb-0"
                      for="metro_check_prefix"></Label>
                    <Row className="mb-1">
                      <Col md="12">
                        <Label
                          className="form-control-label font-weight-bold mb-0"
                          for="metro_check_prefix">Check Offset<span className="text-danger">*</span></Label>
                        <Input
                          id="inputMemoYPosition"
                          type="text"
                          placeholder=""
                          value={checkOffsetPosition}
                          onChange={(e) => setCheckOffsetPosition(e.target.value)}
                        />
                        </Col>
                    </Row>
                  </Col>
                </Row>
                <div className="text-right">
                  <Button
                    id="add-btn"
                    color="success"
                    onClick={saveCheckPositionHandler}
                    size="sm"
                    disabled={metroCheckNumberPrefix <= 0 || coinCheckNumberPrefix <= 0 || receiptCheckNumberPrefix <= 0}
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}


const mapStateToProps = (state) => {
    return {
      
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      resetState: () => dispatch(resetState()),
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(CheckSetting);